import { Game } from "onearm";
import { GameConfig } from "./configs/GameConfig.js";
import { loadSkin } from "./boot/loadSkin.js";

(async () => {
    try {
        const { name, manifest } = await loadSkin();
        console.log(`[skin] loaded: ${name}`);
        GameConfig.resources = { manifest };
        await Game.start(GameConfig);
    } catch (err) {
        console.error("[skin] fatal:", err);
        if (typeof window !== "undefined" && window.__bootSplashError) {
            window.__bootSplashError(err?.message || "Failed to start game.");
        }
        return;
    } finally {
        if (typeof window !== "undefined" && !window.__bootSplashHidden) {
            window.__bootSplashHide?.();
        }
    }
})();
